export default __webpack_public_path__ + "static/media/rocket.0ade0a11.webp";